import { useCallback } from 'react';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import {
	getCountCacheKey,
	getFeatureVisitedCount,
	withEligibilityCache,
} from '../../services/caching/index.tsx';

export const useHasSeenNudgesBefore = () => {
	const userId = useAccountId() || '';

	return useCallback(async (): Promise<boolean> => {
		function hasSeenJpdNudge() {
			const cachedHasSeenJpd = withEligibilityCache('has_seen_jpd', async () => {
				const count = await getFeatureVisitedCount(
					userId,
					getCountCacheKey('crossJoinNudgesJiraToJpd'),
				);
				return count > 0;
			});
			return cachedHasSeenJpd();
		}

		function hasSeenConfluenceNudge() {
			const cachedHasSeenConf = withEligibilityCache('has_seen_conf', async () => {
				const count = await getFeatureVisitedCount(
					userId,
					getCountCacheKey('crossJoinNudgesConfluence'),
				);
				return count > 0;
			});
			return cachedHasSeenConf();
		}

		const hasSeenConfluence = hasSeenConfluenceNudge();
		const hasSeenJpd = hasSeenJpdNudge();
		const hasSeenOtherNudges = await Promise.all([hasSeenConfluence, hasSeenJpd]);
		return hasSeenOtherNudges.some((check) => check);
	}, [userId]);
};
